module.exports = __webpack_public_path__ + "static/media/empty-class.c43aba79.svg";